module.exports = __webpack_public_path__ + "img/ki.2eb8d73f.jpg";